/**
 * Donut de distribución de gastos.
 *
 * El `conic-gradient` lo construye la API: los cortes acumulados tienen que cerrar exactamente
 * en 100 %, y sumando porcentajes redondeados en el cliente quedaría una cuña sin pintar.
 */
import type { ExpenseDistributionSlice } from '@naar/shared';
import { formatEur, formatPercent } from '../lib/format';
import styles from './Charts.module.css';

interface DonutChartProps {
  gradient: string;
  slices: ExpenseDistributionSlice[];
}

export function DonutChart({ gradient, slices }: DonutChartProps) {
  return (
    <div className={styles.donutWrap}>
      <div
        className={styles.donut}
        style={{ background: gradient }}
        role="img"
        aria-label={`Distribución de gastos: ${slices
          .map((slice) => `${slice.label} ${formatPercent(slice.percent)}`)
          .join(', ')}`}
      />
      <div className={styles.donutLegend}>
        {slices.map((slice) => (
          <div
            key={slice.label}
            className={styles.donutRow}
            title={`${slice.label}: ${formatEur(slice.amount)} en 12 meses`}
          >
            <span className={styles.donutSwatch} style={{ background: slice.color }} />
            <span className={styles.donutLabel}>{slice.label}</span>
            <span className={styles.donutValue}>{formatPercent(slice.percent, 0)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
